import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export interface ActivityEntry {
  id: string;
  user_id: string;
  referral_lead_id: string;
  activity_type: string;
  content: string | null;
  created_at: string;
}

export function useActivityLog(referralLeadId?: string) {
  const { user } = useAuth();
  const [activities, setActivities] = useState<ActivityEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchActivities = useCallback(async () => {
    if (!user) { setActivities([]); setLoading(false); return; }
    let query = supabase.from("referral_activity_log").select("*").order("created_at", { ascending: false });
    if (referralLeadId) query = query.eq("referral_lead_id", referralLeadId);
    const { data } = await query;
    setActivities((data as any[]) ?? []);
    setLoading(false);
  }, [user, referralLeadId]);

  useEffect(() => { fetchActivities(); }, [fetchActivities]);

  const addActivity = useCallback(async (entry: { referral_lead_id: string; activity_type: string; content?: string }) => {
    if (!user) return;
    const { error } = await supabase.from("referral_activity_log").insert({ ...entry, user_id: user.id } as any);
    if (error) throw error;
    await fetchActivities();
  }, [user, fetchActivities]);

  return { activities, loading, addActivity, refetch: fetchActivities };
}
